<template>
  <div>
    <div class="cover"></div>
    <div class="box">
      <p>社区信息</p>
      <el-form :model="form" ref="form">
        <el-form-item label="账号" :label-width="formLabelWidth">
          <el-input v-model="form.account" placeholder="请输入账号"></el-input>
        </el-form-item>
        <el-form-item label="社区名称" :label-width="formLabelWidth">
          <el-input
            v-model="form.communityName"
            placeholder="请输入社区名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="描述" :label-width="formLabelWidth">
          <el-input
            type="textarea"
            autosize
            placeholder="请输入描述"
            v-model="form.description"
          >
          </el-input>
        </el-form-item>
        <el-form-item label="图标url" :label-width="formLabelWidth">
          <!-- <el-input v-model="form.icon" placeholder="请输入图标url"></el-input> -->
          <upload v-model="form.icon"></upload>
        </el-form-item>
        <el-form-item label="语言" :label-width="formLabelWidth">
          <el-select v-model="form.language" placeholder="请选择语言">
            <el-option
              v-for="item in languageList"
              :key="item.value"
              :value="item.value"
              :label="item.label"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="二维码url" :label-width="formLabelWidth">
          <!-- <el-input
            v-model="form.twoDimensionCode"
            placeholder="请输入二维码url"
          ></el-input> -->
          <upload v-model="form.twoDimensionCode"></upload>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="save('form')">确 定</el-button>
      </div>
    </div>
  </div>
</template>
<script>
import "../store";
import { mapState } from "vuex";
import api from "../api";
import Upload from 'components/upload';
export default {
  name: "DetailBox",
  props: {
    form: {
      typeof: Object,
      default: {},
    },
    isEdit: {
      typeof: Boolean,
      default: false,
    },
  },
  components: {
    Upload
  },
  data() {
    return {
      dialogVisible: false,
      formLabelWidth: "100px",
    };
  },
  computed: {
    ...mapState("community", ["languageList"]),
  },
  methods: {
    closeDialog() {
      this.$refs["form"].resetFields();
      this.$emit("close");
    },
    save(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isEdit) {
            api
              .updateCommunity({
                ...this.form,
              })
              .then((res) => {
                this.form.account = "";
                this.form.communityName = "";
                this.form.description = "";
                this.form.icon = "";
                this.form.language = 1;
                this.form.id = null;
                this.form.twoDimensionCode = "";
                this.$message({
                  message: "操作成功",
                  type: "success",
                });
                this.$emit("refresh");
              });
            return;
          }
          api
            .addCommunity({
              ...this.form,
            })
            .then(() => {
              this.form.account = "";
              this.form.communityName = "";
              this.form.description = "";
              this.form.icon = "";
              this.form.language = 1;
              this.form.twoDimensionCode = "";
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.$emit("refresh");
            });
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.cover {
  position: fixed;
  z-index: 2;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.6);
}
.box {
  position: fixed;
  padding: 20px 40px 40px;
  width: 500px;
  max-height: 680px;
  overflow-y: auto;
  top: 10%;
  left: 50%;
  margin-left: -290px;
  z-index: 2;
  background-color: #fff;
  border-radius: 10px;
  p {
    font-size: 18px;
  }
  .dialog-footer {
    text-align: right;
  }
}
</style>